import React from 'react'
import { Radio } from 'antd'
import { truncateNumber } from '../../../../helpers/operationMath'
import { useFormConclued } from '../hooks/useFormConclued'
import { Steps } from '../../../../components/Steps'
import { Table } from '../../../../components/Table'
import { Cell } from '../../../../components/Cell'
import { CommentList } from './CommentList'


export const ContainerConcluedModal = ({
    disableIputs
}) => {
    const {
        selectedTab,
        dataConcluded,
        optionRadio,
        updateQuatition
    } = useFormConclued()

    return (
        <Steps currentStep={selectedTab} className={`max-h-[400px] 2xl:max-h-[600px] pb-4 overflow-y-auto scroll-project-details `}>
            <Steps.Step className={'flex flex-col gap-4 mt-4'}>
                <div>
                    <p className='font-semibold text-[10px]'>
                        Horas trabajadas en desarrollo
                    </p>
                    <p className='font-semibold text-[8px] text-[#9A9A9A]'>
                        Ingresa el número de horas en los campos correspondientes
                    </p>
                </div>
                <Table
                    headerRender={(
                        <Cell className={`bg-primaryTwo text-xs text-white`}>
                            <p className='flex-1'>Motivo</p>
                            <p>Horas</p>
                            <p>% vs Pp. Total</p>
                        </Cell>
                    )}
                    className="w-full"
                >
                    {dataConcluded.tableData.map(({ name, hrs, percentage, color }, key) =>
                        <Cell key={key} color={color}>
                            <p className='text-xs flex-1'>{name}</p>
                            <input type="text" disabled value={truncateNumber(hrs)} className='w-12 bg-white h-7 text-end py-1 px-2 text-xs rounded' />
                            <p className='text-xs text-center w-16'>{percentage}%</p>
                        </Cell>
                    )}
                </Table>

                <CommentList
                    nameList='analisis'
                    disableIputs={disableIputs}
                    reasons={{
                        title: "Motivo",
                        description: "Selecciona una o más motivos a donde está dirigido tu comentario",
                        items: dataConcluded.analysis,
                        placeholder: "Selecciona uno o más motivos",
                        isRequired: true,
                    }}
                    comments={{
                        title: "Comentario",
                        description: "Profundiza o justifica la elección anterior",
                        placeholder: "Escribe un comentario",
                        isRequired: true,
                    }}
                />
            </Steps.Step>
            <Steps.Step className={'mt-4'}>
                <CommentList
                    nameList='comentarios'
                    disableIputs={disableIputs}
                    reasons={{
                        title: "Área/áreas",
                        description: "Selecciona una o más áreas a la cual estás dirigiendo el comentario",
                        items: dataConcluded.comments,
                        placeholder: "Selecciona el o los destinatarios",
                        isRequired: true,
                    }}
                    comments={{
                        title: "Comentario",
                        description: "Profundiza o justifica la elección anterior",
                        placeholder: "Escribe un comentario",
                        isRequired: true,
                    }}
                    rules={{
                        lengthNumber: 1
                    }}
                />
            </Steps.Step>
            <Steps.Step className={'mt-4  flex flex-col gap-4'}>
                <div className=' flex flex-col gap-2'>
                    <p className='text-black text-[10px]'>¿La cotización fue adecuada?</p>
                    <Radio.Group
                        size='middle'
                        optionType="button"
                        options={[
                            {
                                label: 'Sí',
                                value: true,
                            },
                            {
                                label: 'No',
                                value: false,
                            }]}
                        onChange={(e) => {
                            updateQuatition(e.target.value)
                        }}
                        value={optionRadio}
                    />
                </div>
                <CommentList
                    nameList='cotizacion'
                    disableIputs={disableIputs}
                    reasons={{
                        title: "Fuera de alcance",
                        description: "Selecciona una o más opciones por las cuales consideres que no asignaron horas o presupuesto correctamente",
                        items: dataConcluded.quotation,
                        placeholder: "Selecciona el o los destinatarios",
                        isRequired: true,
                    }}
                    comments={{
                        title: "Comentario",
                        description: "Profundiza o justifica la elección anterior",
                        placeholder: "Escribe un comentario",
                        isRequired: true,
                    }}
                    rules={{
                        isAddComment: optionRadio
                    }}
                />
            </Steps.Step>
        </Steps>
    )
}
